import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Header } from '../../common/Header';
import { EmptyPage } from '../EmptyPage';
import { OrdersPage } from '../Orders';
import { OfficePage } from '../Office';
import { Notifications } from '../../widgets/Notifications/index';
import { SettingsPage } from '../SettingsPage';
import { StatsPage } from '../Stats';
import { AdvertPage } from '../Advert';

export const Main = ({ isAuth }) => {
    if (!isAuth) return <Navigate to="/login" />;

    return (
        <main>
            <Header />
            <Routes>
                <Route path="/" element={<Navigate to='/orders' />}></Route>
                <Route path="orders" element={<OrdersPage />}></Route>
                <Route path="stats" element={<StatsPage />}></Route>
                <Route path="office" element={<OfficePage />}></Route>
                <Route path="advert/*" element={<AdvertPage />}></Route>
                <Route path="settings/*" element={<SettingsPage />}></Route>
                <Route path="*" element={<EmptyPage message='Страница не найдена' />}></Route>
            </Routes>
            <div id="popup-root"></div>
            <Notifications />
        </main>
    );
};
